import React, { useState, useEffect } from "react";
import search_icon from "../assets/icons/lightOutline/Search.svg";
import back_icon from "../assets/icons/lightOutline/Arrow - Left 2.svg";
import getSearch from "../api/get/getSearch";
import BookItem from "../items/BookItem";

const Header = () => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const toggleSearchModal = () => {
        setIsSearchOpen(!isSearchOpen);
        setQuery("");
        setResults([]);
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (query.trim().length > 1) {
                setLoading(true);
                getSearch(query).then((books) => {
                    setResults(books);
                    setLoading(false);
                });
            } else {
                setResults([]);
            }
        }, 400);

        return () => clearTimeout(delayDebounceFn);
    }, [query]);

    const handlePlay = (bookId, isPaid) => {
        console.log("Play", bookId, isPaid);
    };

    const handleAccessDenied = (bookId) => {
        alert("Бұл кітапқа қол жеткізу үшін оны сатып алу керек.");
    };

    return (
        <>
            <div className="sticky top-0 z-50 flex justify-between items-center px-5 py-4 mb-1 md:hidden bg-[var(--app-color)]">
                <h1 className="text-xl font-bold text-primary">
                    <span className="text-white">Esti</span>
                </h1>
                <img
                    src={search_icon}
                    alt="Search"
                    onClick={toggleSearchModal}
                    className="w-6 h-6 cursor-pointer hover:opacity-80 transition duration-200"
                />
            </div>

            {isSearchOpen && (
                <div className="fixed inset-0 z-50 bg-white flex flex-col">
                    <div className="flex items-center px-4 py-4 border-b shadow-sm">
                        <button
                            onClick={toggleSearchModal}
                            className="mr-4 text-xl text-gray-700 hover:text-black"
                        >
                            <img src={back_icon} alt="Back" />
                        </button>
                        <h2 className="text-lg font-semibold text-gray-800">Іздеу</h2>
                    </div>
                    <div className="p-4">
                        <input
                            type="text"
                            placeholder="Іздеу..."
                            className="w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--app-color)]"
                            autoFocus
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 pb-6">
                        {loading && <p className="text-sm text-gray-500">Жүктелуде...</p>}

                        {!loading && results.length === 0 && query.trim().length > 1 && (
                            <p className="text-sm text-gray-500">Нәтиже табылмады.</p>
                        )}

                        <div className="grid grid-cols-2 gap-4 mt-2">
                            {results.map((book) => (
                                <BookItem
                                    key={book.id}
                                    id={book.id}
                                    image={book.imageUrl}
                                    title={book.title}
                                    price={book.price}
                                    isPaid={book.isPaid}
                                    onPlay={handlePlay}
                                    onBookAccessDenied={handleAccessDenied}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;